// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginButton1-module--button--kap8m"};